import { Fragment, useEffect, useRef, useState } from "react";
import classes from "../userservice/UserDetails.module.css";
import InputLabel from "@mui/material/InputLabel";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import { APPOINTMENT, GENDER, CLINIC } from "./UserServiceDummyData";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getRequest } from "../../../../api/AxiosAPICall";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import { FormikProvider } from "formik";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import Progress from "../../progressbar/RegistrationProgressBar";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import { restictDotHyphenAnde } from "../../../../util/GenralUtils";
import UserTable from "./userTable";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { nanoid } from "nanoid";
const UserService = ({
  formik,
  serviceData,
  sendUserData,
  checkDuplicateUser,
  isUserPresent,
  CheckDuplicateUserEmail,
  isUserEmailPresent,
  CheckDuplicateUserMobile,
  isUserMobilePresent,
}: {
  formik: any;
  serviceData: any;
  sendUserData: any;
  checkDuplicateUser: any;
  isUserPresent: any;
  CheckDuplicateUserEmail: any;
  isUserEmailPresent: any;
  CheckDuplicateUserMobile: any;
  isUserMobilePresent: any;
}) => {
  const [showPassward, setShowPassward] = useState(false);
  const [showPasswardConfirm, setShowPasswardConfirm] = useState(false);
  const [hpTitle, setHpTitle] = useState<any>([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [userData, setUserData] = useState([]) as any;
  const [userIdForEdit, setUserIdForEdit] = useState();
  const [disableRegister, setDisableRegister] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [clinicianUsers, setClinicianUsers] = useState<any>(0);
  const [adminUsers, setAdminUsers] = useState<any>(0);
  const isMounted = useRef<any>();

  const dispatch = useDispatch();
  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
      disableFocusListener
      {...props}
      arrow
      classes={{ popper: className }}
    />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#E2F1FF",
      "&::before": {
        border: "1px solid #b1b1b1",
      },
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#E2F1FF",
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      border: "1px solid #b1b1b1",
      fontSize: 11,
      maxWidth: "250px",
    },
  }));

  useEffect(() => {
    if (Object.values(userData)?.length === 0) {
      setDisableRegister(true);
    } else {
      setDisableRegister(false);
    }

    if (adminUsers > 0 && clinicianUsers > 0) {
      setDisableRegister(false);
    }
    // eslint-disable-next-line
  }, [Object.values(userData)?.length, adminUsers, clinicianUsers]);

  //This useEffect used to fetch Hp Title
  useEffect(() => {
    isMounted.current = true;

    const fetchHpTitle = async () => {
      const response = await getRequest("establishmentListItems", {
        params: {
          applistName: "Title",
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setHpTitle(response?.data);
      }
    };
    fetchHpTitle();

    return () => {
      isMounted.current = false;
      setHpTitle([]);
    };
    // eslint-disable-next-line
  }, []);

  const setTouchForAll = () => {
    formik.setTouched({
      clinicName: true,
      userName: true,
      password: true,
      confirmPassword: true,
      givenName: true,
      familyName: true,
      userEmailId: true,
      userMobile: true,
      mbttNumber: true,
    });
  };

  const setUntouchForAll = () => {
    formik.setTouched({
      clinicName: false,
      userName: false,
      password: false,
      confirmPassword: false,
      givenName: false,
      familyName: false,
      userEmailId: false,
      userMobile: false,
      mbttNumber: false,
    });
  };

  const ResetAllField = (formik: any) => {
    formik.setFieldValue("clinicName", "");
    formik.setFieldValue("userName", "");
    formik.setFieldValue("password", "");
    formik.setFieldValue("confirmPassword", "");
    formik.setFieldValue("title", "");
    formik.setFieldValue("givenName", "");
    formik.setFieldValue("familyName", "");
    formik.setFieldValue("gender", "");
    formik.setFieldValue("userEmailId", "");
    formik.setFieldValue("userMobile", "");
    formik.setFieldValue("mbttNumber", "");
    formik.setFieldValue("clinicalUser", false);
    formik.setFieldValue("clericalUser", false);
    formik.setFieldValue("FinancialUser", false);
    formik.setFieldValue("AdministratorUser", false);
    formik.setFieldValue("NurseUser", false);
    formik.setFieldValue("HpDefaultAppt", true);
    if (Object.keys(formik.errors).length !== 0) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Please enter all required fields.",
          "top",
          "center"
        )
      );
    }
  };

  const handleEdit = async (data: any, index: any) => {
    setUserIdForEdit(data.userId);
    window.scrollTo(0, 0);
    setIsUpdate(true);
    formik.setFieldValue("clinicName", data.clinicName);
    formik.setFieldValue("userName", data.userName);
    formik.setFieldValue("password", data.password);
    formik.setFieldValue("confirmPassword", data.confirmPassword);
    formik.setFieldValue("appointment", data.appointment);
    formik.setFieldValue("title", data.title);
    formik.setFieldValue("givenName", data.givenName);
    formik.setFieldValue("familyName", data.familyName);
    formik.setFieldValue("gender", data.gender);
    formik.setFieldValue("userEmailId", data.userEmailId);
    formik.setFieldValue("userMobile", data.userMobile);
    formik.setFieldValue("mbttNumber", data.mbttNumber);
    formik.setFieldValue("clinicalUser", data.clinicalUser);
    formik.setFieldValue("clericalUser", data.clericalUser);
    formik.setFieldValue("FinancialUser", data.FinancialUser);
    formik.setFieldValue("AdministratorUser", data.AdministratorUser);
    formik.setFieldValue("NurseUser", data.NurseUser);
    formik.setFieldValue("HpDefaultAppt", data.HpDefaultAppt);
  };

  const handleUpdate = (data: any, formik: any) => {
    const index = data.findIndex((object: any) => {
      return object.userId === userIdForEdit;
    });

    if (
      formik.AdministratorUser === true &&
      formik.AdministratorUser !== data[index].AdministratorUser
    ) {
      setAdminUsers((adminUsers: any) => adminUsers + 1);
    }
    if (
      formik.AdministratorUser === false &&
      formik.AdministratorUser !== data[index].AdministratorUser
    ) {
      setAdminUsers((adminUsers: any) => adminUsers - 1);
    }

    if (
      formik.clinicalUser === true &&
      formik.clinicalUser !== data[index].clinicalUser
    ) {
      setClinicianUsers((clinicianUsers: any) => clinicianUsers + 1);
    }
    if (
      formik.clinicalUser === false &&
      formik.clinicalUser !== data[index].clinicalUser
    ) {
      setClinicianUsers((clinicianUsers: any) => clinicianUsers - 1);
    }

    if (index !== -1) {
      data[index].userId = userIdForEdit;
      data[index].clinicName = formik.clinicName;
      data[index].userName = formik.userName;
      data[index].password = formik.password;
      data[index].confirmPassword = formik.confirmPassword;
      data[index].title = formik.title;
      data[index].givenName = formik.givenName;
      data[index].familyName = formik.familyName;
      data[index].gender = formik.gender;
      data[index].userEmailId = formik.userEmailId;
      data[index].userMobile = formik.userMobile;
      data[index].mbttNumber = formik.mbttNumber;
      data[index].clinicalUser = formik.clinicalUser;
      data[index].clericalUser = formik.clericalUser;
      data[index].FinancialUser = formik.FinancialUser;
      data[index].AdministratorUser = formik.AdministratorUser;
      data[index].NurseUser = formik.NurseUser;
      data[index].HpDefaultAppt = formik.HpDefaultAppt;
    }
  };

  const handleDelete = (event: any, removeIndex: any) => {
    ResetAllField(formik);
    setUntouchForAll();
    setIsUpdate(false);
    setUserData((oldArray: any) => {
      if (oldArray[removeIndex].AdministratorUser === true) {
        setAdminUsers((adminUsers: any) => adminUsers - 1);
      }
      if (oldArray[removeIndex].clinicalUser === true) {
        setClinicianUsers((clinicianUsers: any) => clinicianUsers - 1);
      }
      return oldArray.filter((value: any, index: any) => index !== removeIndex);
    });

    dispatch(
      setSnackbar(
        true,
        2000,
        "success",
        "User Deleted Sucessfully!",
        "top",
        "center"
      )
    );
  };

  const updateUser = () => {
    setTouchForAll();
    const isIdFound = userData?.some((element: any) => {
      if (
        (formik?.values?.userName?.toUpperCase() ===
          element?.userName?.toUpperCase() ||
          formik?.values?.userEmailId?.toUpperCase() ===
            element?.userEmailId?.toUpperCase() ||
          parseInt(formik?.values?.userMobile) ===
            parseInt(element?.userMobile)) &&
        userIdForEdit !== element?.userId
      ) {
        return true;
      }
      return false;
    });
    if (isIdFound) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cannot have two users with identical usernames, email and mobile number, Please enter unique username, email and mobile number.",
          "top",
          "center"
        )
      );
      setIsUpdating(false);
    }
    if (
      !isIdFound &&
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      setIsUpdating(true);
      setIsUpdate(false);
      ResetAllField(formik);
      handleUpdate(userData, formik.values);
      setUntouchForAll();

      setTimeout(() => {
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "User Updated Sucessfully!",
            "top",
            "center"
          )
        );
        setIsUpdating(false);
      }, 1000);
    }
  };

  const addUser = () => {
    setTouchForAll();
    const isFound = userData?.some((element: any) => {
      if (
        (formik?.values?.userName?.toUpperCase() ===
          element?.userName?.toUpperCase() ||
          formik?.values?.userEmailId?.toUpperCase() ===
            element?.userEmailId?.toUpperCase() ||
          parseInt(formik?.values?.userMobile) ===
            parseInt(element?.userMobile)) &&
        userIdForEdit !== element?.userId
      ) {
        return true;
      }
      return false;
    });

    if (isFound) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cannot have two users with identical usernames, email addresses, or mobile numbers.",
          "top",
          "center"
        )
      );
      setIsAdding(false);
    }

    if (formik.values.clinicalUser === true) {
      setClinicianUsers((clinicianUsers: any) => clinicianUsers + 1);
    }
    if (formik.values.AdministratorUser === true) {
      setAdminUsers((adminUsers: any) => adminUsers + 1);
    }
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0 &&
      !isFound &&
      formik.values.userName !== undefined &&
      formik.values.userName !== "" &&
      formik.values.userName !== null
    ) {
      userData.push(formik.values);
      ResetAllField(formik);
      formik.resetForm();
      formik.setFieldValue("userId", +formik?.values?.userId + 1);
      setUntouchForAll();
      setTimeout(() => {
        dispatch(
          setSnackbar(
            true,
            2000,
            "success",
            "User Added Sucessfully!",
            "top",
            "center"
          )
        );
        setIsAdding(false);
      }, 1000);
    } else {
      setIsAdding(false);
    }
  };

  return (
    <Fragment>
      <Progress activeStep={3} />
      <FormikProvider value={formik}>
        <CommonCard>
          <Typography variant="h1" className={globalClasses.typography}>
            Health Care Professionals
          </Typography>

          <Grid
            container
            spacing={2}
            className={classes.rowSpace}
            direction="row"
            sx={{ marginBottom: "20px" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              className={classes.formControlZeroMarginTop}
            >
              <input
                type="hidden"
                id="clinicianUsers"
                name="clinicianUsers"
                value={clinicianUsers}
                onChange={(event: any) => {
                  setClinicianUsers(event.target.value);
                }}
              />
              <input
                type="hidden"
                id="adminUsers"
                name="adminUsers"
                value={adminUsers}
                onChange={(event: any) => {
                  setAdminUsers(event.target.value);
                }}
              />
              <SelectField
                id="clinicName"
                name="clinicName"
                headerText="Select Clinic"
                label="Select Clinic"
                value={formik.values.clinicName}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                isrequired={true}
                list={(serviceData?.clinicDetails ?? CLINIC).map(
                  (service: any, index: number) => (
                    <MenuItem
                      key={nanoid()}
                      value={service.clinicName ?? service.value}
                    >
                      {service.clinicName ?? service.value}
                    </MenuItem>
                  )
                )}
                error={
                  formik.touched.clinicName && Boolean(formik.errors.clinicName)
                }
              />
              {formik.touched.clinicName && formik.errors.clinicName && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  {formik.errors.clinicName}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="userName"
                name="userName"
                label="Username"
                inputvalues={formik.values.userName}
                changeevent={formik.handleChange}
                blurevent={(event: any, value: any) => {
                  formik.handleBlur("userName")(event);
                  checkDuplicateUser(event.target.value);
                }}
                isrequired={true}
                errormessage={
                  formik.touched.userName && Boolean(formik.errors.userName)
                }
                message={formik.touched.userName && formik.errors.userName}
              />
              {isUserPresent && !formik.errors.userName && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px", marginLeft: "14px" }}
                >
                  User already exists
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="password"
                name="password"
                label="Password"
                inputvalues={formik.values.password}
                type={showPassward ? "text" : "password"}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={true}
                errormessage={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                message={formik.touched.password && formik.errors.password}
                customprops={
                  <>
                    <IconButton
                      title="Show/Hide Password"
                      onClick={() => setShowPassward(!showPassward)}
                    >
                      {showPassward ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                    <LightTooltip
                      title={
                        <Typography
                          color="inherit"
                          sx={{
                            fontSize: "12px",
                            wordWrap: "break-word",
                          }}
                        >
                          {
                            "Password must have minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter and 1 number."
                          }
                        </Typography>
                      }
                    >
                      <InfoIcon />
                    </LightTooltip>
                  </>
                }
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password"
                inputvalues={formik.values.confirmPassword}
                type={showPasswardConfirm ? "text" : "password"}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                onCopy={false}
                onPaste={false}
                isrequired={true}
                errormessage={
                  formik.touched.confirmPassword &&
                  Boolean(formik.errors.confirmPassword)
                }
                message={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                customprops={
                  <IconButton
                    title="Show/Hide Password"
                    onClick={() => setShowPasswardConfirm(!showPasswardConfirm)}
                  >
                    {showPasswardConfirm ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SelectField
                id="appointment"
                name="appointment"
                headerText="Patient Appointments Required"
                label="Patient Appointments Required"
                value={formik.values.appointment}
                disable
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                options={APPOINTMENT}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SelectField
                id="title"
                name="title"
                headerText="Title"
                label="Title"
                value={formik.values.title}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                options={hpTitle}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="givenName"
                name="givenName"
                label="Given Name"
                inputvalues={formik.values.givenName}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={true}
                errormessage={
                  formik.touched.givenName && Boolean(formik.errors.givenName)
                }
                message={formik.touched.givenName && formik.errors.givenName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="familyName"
                name="familyName"
                label="Family Name"
                inputvalues={formik.values.familyName}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={true}
                errormessage={
                  formik.touched.familyName && Boolean(formik.errors.familyName)
                }
                message={formik.touched.familyName && formik.errors.familyName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SelectField
                id="gender"
                name="gender"
                headerText="Select Gender"
                label="Select Gender"
                value={formik.values.gender}
                blurevent={formik.handleBlur}
                changeevent={formik.handleChange}
                list={GENDER.map((option: any) => (
                  <MenuItem key={option.id} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="userEmailId"
                name="userEmailId"
                label="Email"
                inputvalues={formik.values.userEmailId}
                changeevent={formik.handleChange}
                blurevent={(event: any, value: any) => {
                  formik.handleBlur("userEmailId")(event);
                  CheckDuplicateUserEmail(event.target.value);
                }}
                isrequired={true}
                errormessage={
                  formik.touched.userEmailId &&
                  Boolean(formik.errors.userEmailId)
                }
                message={
                  formik.touched.userEmailId && formik.errors.userEmailId
                }
              />
              {isUserEmailPresent && !formik.errors.userEmailId && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  Email already exists
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="userMobile"
                name="userMobile"
                label="Mobile"
                type="number"
                inputvalues={formik.values.userMobile}
                changeevent={formik.handleChange}
                blurevent={(event: any, value: any) => {
                  formik.handleBlur("userMobile")(event);
                  CheckDuplicateUserMobile(event.target.value);
                }}
                downevent={restictDotHyphenAnde}
                isrequired={true}
                errormessage={
                  formik.touched.userMobile && Boolean(formik.errors.userMobile)
                }
                message={formik.touched.userMobile && formik.errors.userMobile}
                placeholder="e.g. 8888888888"
              />
              {isUserMobilePresent && !formik.errors.userMobile && (
                <Typography
                  color="#d32f2f"
                  component={"p"}
                  variant="subtitle2"
                  sx={{ fontSize: "12px", padding: "5px" }}
                >
                  Mobile Number already exists
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <InputField
                id="mbttNumber"
                name="mbttNumber"
                label="MBTT Number"
                inputvalues={formik.values.mbttNumber}
                changeevent={formik.handleChange}
                blurevent={formik.handleBlur}
                isrequired={
                  formik.values.title === "Dr" || formik.values.title === "Prof"
                    ? true
                    : false
                }
                errormessage={
                  formik.touched.mbttNumber && Boolean(formik.errors.mbttNumber)
                }
                message={formik.touched.mbttNumber && formik.errors.mbttNumber}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControlLabel
                control={
                  <InputLabel sx={{ display: "none" }}>User Role</InputLabel>
                }
                label="User Role"
                aria-label="User Role"
                className={classes.userRoleMargin}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    id="clinicalUser"
                    name="clinicalUser"
                    value={formik.values.clinicalUser}
                    checked={formik.values.clinicalUser}
                    disabled={formik.values.NurseUser === true ? true : false}
                  />
                }
                label="Clinical"
                id="clinicalUser"
                name="clinicalUser"
                value={formik.values.clinicalUser}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    id="clericalUser"
                    name="clericalUser"
                    value={formik.values.clericalUser}
                    checked={formik.values.clericalUser}
                  />
                }
                label="Clerical  "
                id="clericalUser"
                name="clericalUser"
                value={formik.values.clericalUser}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    id="FinancialUser"
                    name="FinancialUser"
                    value={formik.values.FinancialUser}
                    checked={formik.values.FinancialUser}
                  />
                }
                label="Financial"
                id="FinancialUser"
                name="FinancialUser"
                value={formik.values.FinancialUser}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    id="AdministratorUser"
                    name="AdministratorUser"
                    value={formik.values.AdministratorUser}
                    checked={formik.values.AdministratorUser}
                  />
                }
                label="Administrator"
                id="AdministratorUser"
                name="AdministratorUser"
                value={formik.values.AdministratorUser}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    id="NurseUser"
                    name="NurseUser"
                    value={formik.values.NurseUser}
                    checked={formik.values.NurseUser}
                    disabled={
                      formik.values.clinicalUser === true ||
                      formik.values.HpDefaultAppt === true
                        ? true
                        : false
                    }
                  />
                }
                label="Nurse"
                id="NurseUser"
                name="NurseUser"
                value={formik.values.NurseUser}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id="HpDefaultAppt"
                    name="HpDefaultAppt"
                    value={formik.values.HpDefaultAppt}
                    checked={formik.values.HpDefaultAppt}
                    disabled={formik.values.NurseUser === true ? true : false}
                  />
                }
                label="HP Default Appointment"
                id="HpDefaultAppt"
                name="HpDefaultAppt"
                value={formik.values.HpDefaultAppt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </Grid>
          </Grid>
        </CommonCard>

        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "15px",
          }}
        >
          {isUpdate ? (
            <ButtonComponent
              buttonclass={globalClasses.addAnotherServiceGreen}
              variant="contained"
              size="small"
              onClick={(event: any) => {
                if (
                  isUserPresent ||
                  isUserEmailPresent ||
                  isUserMobilePresent
                ) {
                  window.scrollTo(0, 0);
                } else {
                  updateUser();
                }
                event.preventDefault();
              }}
              loader={true}
              label="Update"
            />
          ) : (
            <form>
              <ButtonComponent
                buttonclass={globalClasses.addAnotherServiceGreen}
                variant="contained"
                size="small"
                onClick={(event: any) => {
                  if (
                    isUserPresent ||
                    isUserEmailPresent ||
                    isUserMobilePresent
                  ) {
                    window.scrollTo(0, 0);
                  } else {
                    setIsAdding(true);
                    addUser();
                  }
                  event.preventDefault();
                }}
                label="Add User"
              />
            </form>
          )}
        </Grid>
        <UserTable
          getData={userData}
          setData={handleEdit}
          deleteUser={handleDelete}
        />
        <Grid container spacing={2} direction="row">
          <Grid item xs={12} md={12}>
            <form>
              <ButtonComponent
                variant="contained"
                size="small"
                type="submit"
                buttonclass={classes.registerUserButton}
                onClick={(event: any) => {
                  if (clinicianUsers > 0 && adminUsers > 0) {
                    sendUserData(userData);
                  } else {
                    dispatch(
                      setSnackbar(
                        true,
                        null,
                        "warning",
                        "Please add Administrator and Clinical users to proceed further!",
                        "top",
                        "center"
                      )
                    );
                    setDisableRegister(true);
                  }

                  event.preventDefault();
                }}
                disable={disableRegister}
                label="Register User"
              />
            </form>
          </Grid>
        </Grid>
      </FormikProvider>

      {(isAdding || isUpdating) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          {isAdding && (
            <Typography fontWeight="600" fontSize="20px">
              Adding user information...!
            </Typography>
          )}
          {isUpdating && (
            <Typography fontWeight="600" fontSize="20px">
              Updating user information...!
            </Typography>
          )}

          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}
    </Fragment>
  );
};

export default UserService;
